import React from "react";
import { fmtCurrency } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Trophy } from "lucide-react";

export default function RepLeaderboard({ leaderboard }) {
  const rows = leaderboard || [];
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Trophy className="w-4 h-4 text-primary" /> Rep Leaderboard
        </CardTitle>
      </CardHeader>
      <CardContent>
        {rows.length ? (
          <div className="max-h-[280px] overflow-y-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Rep</TableHead>
                  <TableHead className="text-right">Won</TableHead>
                  <TableHead className="text-right">Open</TableHead>
                  <TableHead className="text-right">Win%</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {rows.slice(0, 8).map((r) => (
                  <TableRow key={r.owner_id}>
                    <TableCell className="font-medium text-foreground">{r.name}</TableCell>
                    <TableCell className="text-right">{fmtCurrency(r.won_value)}</TableCell>
                    <TableCell className="text-right text-muted-foreground">
                      {fmtCurrency(r.open_value)}
                    </TableCell>
                    <TableCell className="text-right">
                      <Badge variant={r.win_rate >= 50 ? "default" : "secondary"}>{r.win_rate}%</Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          <div className="h-[120px] flex items-center justify-center text-sm text-muted-foreground text-center px-4">
            No owner/closed-deal data for this period.
          </div>
        )}
      </CardContent>
    </Card>
  );
}
